// extracted by mini-css-extract-plugin
module.exports = {"medium":"only screen and (min-width: 768px)","cities":"cities-3apxW","cityColumn":"cityColumn-2yVIg","city":"city-b00cV"};